<template>
  <div :busy="isLoading">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div class="table-wrapper">
      <b-table
        :busy="isLoading"
        head-variant="light"
        :no-local-sorting="true"
        :items="items"
        :fields="getAllFields"
        :current-page="currentPage"
        per-page="0"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :sticky-header="height"
        no-border-collapse
        responsive
        show-empty
        empty-text="Non ci sono informazioni da mostrare"
        small
        @sort-changed="sortingChanged"
      >
        <template #table-busy>
          <table-skeleton />
        </template>
        <template #empty>
          <template v-if="newClaimBtn">
            <div
              class="d-flex flex-column justify-content-center align-items-center my-3"
              style="max-width: max-content; margin-inline: auto"
            >
              <p class="mb-2">
                Effettua una ricerca oppure, se non trovi risultati, crea un
                nuovo Sinistro cliccando sul pulsante qui sotto
              </p>
              <b-button
                class="btn-create"
                type="button"
                variant="primary"
                size="sm"
                @click="onAddNewClaim"
                title="Crea"
                :disabled="!canVerb(resource, 'store')"
                style="max-width: max-content"
              >
                <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                Crea
              </b-button>
            </div>
          </template>
          <template v-else>
            <empty-table
              :isTableInModal="isTableInModal"
              :performedSearch="performedSearch"
              :automaticPerformedSearch="automaticPerformedSearch"
              :filterCount="filterCount"
            />
          </template>
        </template>
        <template #cell(claim_number)="{ item }">
          {{
            joinValues([
              item.insurance_policy && item.insurance_policy.insurer
                ? item.insurance_policy.insurer
                  ? item.insurance_policy.insurer.code
                  : null
                : null,
              item.insurance_policy && item.insurance_policy.insurer
                ? findAndGet(
                  $store.state.auth.mandate_codes,
                  "id",
                  item.insurance_policy.mandate_code_id,
                  "code"
                )
                : null,
              item.referring_at,
              item.number,
            ])
          }}
          <!-- ? $store.state.auth.mandate_codes.find(
                    (e) => e.id === item.insurance_policy.mandate_code_id
                  ).code -->
        </template>
        <template #cell(claim_type)="{ item }">
          {{ item.claim_type.text }}
        </template>
        <template #cell(status_claim)="{ item }">
          {{ item.status_claim.text }}
        </template>
        <template #cell(product)="{ item }">
          <span>{{ item.insurance_policy.insurance_risk.title }}</span>
        </template>
        <template #cell(insurer_code)="{ item }">
          {{
            joinValues([
              item.insurance_policy &&
              item.insurance_policy.insurer &&
              item.insurance_policy.insurer.code
                ? item.insurance_policy.insurer.code
                : null,
              item.insurance_policy && item.insurance_policy.number
                ? item.insurance_policy.number
                : null,
            ])
          }}
        </template>
        <template #cell(customer)="{ item }">
          <template v-if="item.insurance_policy">
            {{
              item.insurance_policy.registry
                ? item.insurance_policy.registry.status_registry.value === 1
                  ? item.insurance_policy.registry.attributables.CNAM
                  : item.insurance_policy.registry.attributables.SURN +
                  " " +
                  item.insurance_policy.registry.attributables.NAME
                : ""
            }}
          </template>
        </template>
        <template #cell(counterpart)="{ item }">
            <span
              v-for="(claim_party, index) in item.claim_parties"
              :key="index"
            >
              {{
                claim_party.status_claimparty.value === 1
                  ? `${claim_party.attributables.FULN} `
                  : ""
              }}
            </span>
        </template>
        <template #cell(inspector)="{ item }">
            <span
              v-for="(claim_party, index) in item.claim_parties"
              :key="index"
            >
              {{
                claim_party.status_claimparty.value === 5
                  ? `${claim_party.attributables.FULN} `
                  : ""
              }}
            </span>
        </template>
        <template #cell(surveyor)="{ item }">
            <span
              v-for="(claim_party, index) in item.claim_parties"
              :key="index"
            >
              {{
                claim_party.status_claimparty.value === 2
                  ? `${claim_party.attributables.FULN} `
                  : ""
              }}
            </span>
        </template>
        <template #cell(registry_group)="{ item }">
          <template v-if="item.insurance_policy">
            {{
              item.insurance_policy.registry
                ? item.insurance_policy.registry.registry_groups.length && item.insurance_policy.registry.registry_groups.find(
                  registry_group => registry_group.pivot.primary.value === 'Y'
                ) ? item.insurance_policy.registry.registry_groups.find(
                  registry_group => registry_group.pivot.primary.value === 'Y'
                ).code : ""
                : "",
            }}
          </template>
        </template>
        <template #cell(broker)="{ item }">
          <template v-if="item.insurance_policy">
              <span
                v-html="toInfoData(item.insurance_policy.broker, 'broker', 0)"
              ></span>
          </template>
        </template>
        <template #cell(note_counter)="row" v-if="items.length">
          <div
            role="button"
            class="info-box float-left"
            @click="customOpenNoteModal(row.item, row.index, $event.target)"
            v-b-tooltip="
                toTooltipTask(
                  row.item.tasks.filter((task) => task.task_type.value === 2),
                  'Note',
                  [
                    { label: 'Titolo', key: 'title' },
                    { label: 'Descrizione', key: 'description' },
                    {
                      label: 'Ultimo aggiornamento',
                      key: 'last_update',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                    {
                      label: 'Creato da',
                      key: 'owner_id',
                      formatter: (val) => retriveOwner(val),
                    },
                    {
                      label: 'Data creazione',
                      key: 'created_at',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                  ]
                )
              "
          >
            {{
              row.item.tasks.filter((task) => task.task_type.value === 2)
                .length
            }}
          </div>
        </template>
        <template #cell(document_counter)="row" v-if="items.length">
          <div
            role="button"
            class="info-box float-left"
            @click="customOpenDocModal(row.item, row.index, $event.target)"
            v-b-tooltip="
                toTooltipTask(row.item.documents, 'Documenti', [
                  { label: 'Titolo', key: 'title' },
                  { label: 'Descrizione', key: 'note' },
                  {
                    label: 'Ultimo aggiornamento',
                    key: 'last_update',
                    formatter: (val) => {
                      return moment(val).format('DD/MM/YYYY HH:mm:ss');
                    },
                  },
                ])
              "
          >
            {{ row.item.documents.length }}
          </div>
        </template>
        <template #cell(insurer)="{ item }">
          {{
            item.insurance_policy
              ? item.insurance_policy.insurer
                ? item.insurance_policy.insurer.formatted_title
                : ""
              : ""
          }}
        </template>
        <template #cell(actions)="row">
          <div class="action-buttons">
            <b-button
              v-if="actions.includes('infomodal')"
              size="sm"
              variant="lisaweb"
              @click="openModal(row.item, row.index, $event.target)"
              class="mt-1 mr-1"
              title="Modale Dettagli"
            >
              <!-- <base-icon name="eye" width="22"></base-icon> -->
              <base-icon name="eye" width="22"></base-icon>
            </b-button>

            <b-button
              v-if="actions.includes('details')"
              size="sm"
              variant="lisaweb"
              @click="row.toggleDetails"
              class="mt-1 mr-1"
              :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
            >
              <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
              <b-icon v-else icon="chevron-down"></b-icon>
            </b-button>

            <b-button
              v-if="actions.includes('edit')"
              size="sm"
              variant="lisaweb"
              @click="onEdit(row.item.id, row.item)"
              class="mt-1 mr-1"
              title="Modifica"
            >
              <!-- <base-icon name="edit" width="22"></base-icon> -->
              <base-icon name="edit" width="22"></base-icon>
            </b-button>

            <b-button
              v-if="actions.includes('destroy')"
              size="sm"
              variant="lisaweb"
              @click="onDestroy(row.item.id)"
              class="mt-1 mr-1"
              title="Elimina"
            >
              <!-- <base-icon name="trash" width="22" height="22"></base-icon> -->
              <base-icon name="trash" width="22" height="22"></base-icon>
            </b-button>
          </div>
        </template>
        <template #row-details="row">
          <b-card>
            <b-row
              class="mb-2"
              v-for="(value, key) in customized(row.item)"
              :key="key"
            >
              <b-col sm="3" class="text-sm-right"
              ><b>{{ key | capitalize }}:</b></b-col
              >
              <b-col>{{ value }}</b-col>
            </b-row>
          </b-card>
        </template>
        <template #cell()="{ value }">
          <span>{{ value }}</span>
        </template>
      </b-table>
    </div>
    <pagination-skeleton v-if="isLoading && !noPagination" />
    <div
      class="pagination-wrapper"
      v-if="!isLoading && !noPagination && items.length"
    >
      <div class="info">
        <div class="show-text">
          <p>
            <label for="per-page-select-registry"
            >Numero di risultati per pagina:</label
            >
          </p>
        </div>
        <div class="group">
          <b-form-group label-for="per-page-select">
            <b-form-select
              id="per-page-select-registry"
              v-model="perPage"
              :options="pageOptions"
              style="width: 68px"
              size="sm"
              @change="onPageChange(1)"
              :disabled="!items.length"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="page">
          <p>
            Risultati da
            <strong>{{ formatItemsFrom }}</strong> a
            <strong>{{ formatItemsTo }}</strong> su un totale di
            <strong>{{ formatTotalItems }}</strong>
          </p>
        </div>
      </div>
      <div class="info-action">
        <div class="pagination" v-if="totalItems">
          <b-pagination
            v-model="currentPage"
            limit="3"
            :total-rows="totalItems"
            :per-page="perPage"
            size="sm"
            @change="onPageChange"
          >
            <template #page="{ page, active }">
                <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
            </template>
            <template v-slot:first-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
            </template>
            <template v-slot:prev-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
            </template>
            <template v-slot:next-text>
                <span
                ><base-icon
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
            </template>
            <template v-slot:last-text>
                <span
                ><base-icon
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
            </template>
          </b-pagination>
        </div>
        <div
          class="input_pagination"
          v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
        >
          <base-input-pagination
            @pagination="onInputPagination"
          ></base-input-pagination>
        </div>
      </div>
    </div>
    <b-modal
      :id="infomodalName"
      @show="onModalShow"
      @hidden="onModalHidden"
      :title="modalTitle"
      size="xl"
      scrollable
      ok-only
      ok-title="Chiudi"
      ok-variant="-transparent"
      header-bg-variant="lisaweb"
      no-close-on-backdrop
    >
      <template v-slot:modal-header-close>
        <base-icon name="close" width="14" height="14"/>
      </template>
      <div>
        <b-tabs content-class="pt-1" lazy v-model="tabIndex">
          <b-tab
            v-for="(tab, index) in tabs"
            :key="index"
            @click="setTab(tab, index)"
            :title="tab.text"
            :active="index === tabIndex"
            title-item-class="lisaweb"
          >
            <button-group-tab></button-group-tab>
            <keep-alive>
              <component
                v-if="selected === tab.name"
                :is="selected"
                :resourceId="modalResourceId"
                @fetch="fetch"
              ></component>
            </keep-alive>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>
<script>
import template from "./template";
import BaseIcon from "@/components/BaseIcon";
import BaseInputPagination from "@/components/form/BaseInputPagination";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import General from "@/components/wallet/claims/details/General";
import Registry from "@/components/wallet/claims/details/Registry";
import Policy from "@/components/wallet/claims/details/Policy";
import Surveyor from "@/components/wallet/claims/details/Surveyor";
import Counterparties from "@/components/wallet/claims/details/Counterparties";
import Garage from "@/components/wallet/claims/details/Garage";
import Notes from "@/components/wallet/claims/details/Notes";
import Todo from "@/components/wallet/claims/details/Todo";
import Driver from "@/components/wallet/claims/details/Driver";
import Appointments from "@/components/wallet/claims/details/Appointments";
import Documents from "@/components/wallet/claims/details/Documents";
import {toLocaleCurrency} from "@/utils/strings";
import {mapGetters} from "vuex";
import moment from "moment";
import {getRiskTypeDescription} from "../../utils/payments";
import EmptyTable from "@/components/EmptyTable.vue";


moment.locale("it");

export default {
  name: "ClaimsTable",
  extends: template,
  data() {
    return {
      tabs: [
        {name: "General", text: "Generale"},
        {name: "Registry", text: "Anagrafica"},
        {name: "Policy", text: "Polizza"},
        {name: "Surveyor", text: "Perito"},
        {name: "Counterparties", text: "Controparti"},
        {name: "Driver", text: "Conducente"},
        {name: "Garage", text: "Officina"},
        {name: "Appointments", text: "Appuntamenti"},
        {name: "Notes", text: "Note"},
        {name: "Todo", text: "Attività"},
        {name: "Documents", text: "Doc"},
      ],
      selected: "General",
      modalResourceId: null,
      tabIndex: 0,
    };
  },
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    newClaimBtn: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseIcon,
    BaseInputPagination,
    General,
    Registry,
    Policy,
    Surveyor,
    Counterparties,
    Driver,
    Notes,
    Documents,
    ButtonGroupTab,
    Todo,
    Appointments,
    Garage,
    EmptyTable,
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    getRiskTypeDescription,
    onModalShow() {
      if (this.tabIndex < this.tabs.length)
        this.setTab(this.tabs[this.tabIndex], this.tabIndex);
    },
    onModalHidden() {
      this.setTab({name: "General", text: "Generale"}, 0);
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    onAddNewClaim() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    customOpenNoteModal(item, index, target) {
      this.tabIndex = 8; // TabIndex ID delle Note
      this.openModal(item, index, target);
    },
    customOpenDocModal(item, index, target) {
      this.tabIndex = 10; // TabIndex ID dei Documenti
      this.openModal(item, index, target);
    },
    customized(item) {
      let c = {};
      c.data_accadimento_sinistro = moment(item.occurred_at).format(
        "DD/MM/YYYY"
      );
      c.data_ultima_liquidazione_parziale = moment(
        item.partially_settled_at
      ).format("DD/MM/YYYY");
      c.totale_liquidato = toLocaleCurrency(item.settled_total);
      c.franchigia = toLocaleCurrency(item.deductible);
      c.ammontare_in_riserva = toLocaleCurrency(item.amount_in_reserve);
      let customAttributes = this.convertFromCustomAttributesToFields(
        this.customAttributes()(this.repository)
      );
      Object.keys(customAttributes).forEach((i) => {
        let value = customAttributes[i].key.split(".");
        let label = customAttributes[i].label;
        c[label] = item.attributables[value[value.length - 1]];
      });
      return c;
    },
    retriveOwner(value) {
      if (!value) return "-";
      return (
        this.getUsers().find((user) => user.value === value)?.username ?? "-"
      );
    },
    ...mapGetters("auth", {
      getUsers: "users",
    }),
  },
};
</script>
